module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/cover.5a3b9760.png";